import { useState } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
// import "./App.css";
import Dashboard from "./containers/Dashboard/Dashboard";
import Login from "./containers/Login-Page";
import { useAuth } from "./AuthContext";
import { routerLinks } from "@/config/dashboard";

// function PrivateRoute({
//   children,
//   path,
// }: {
//   children: JSX.Element;
//   path: string;
// }) {
//   const { isAuthenticated } = useAuth();

//   return isAuthenticated ? (
//     <Route path={path} element={children} />
//   ) : (
//     <Route path={path} element={<Navigate to="/login" />} />
//   );
// }

function PrivateRoute({ children }: { children: JSX.Element }) {
  const { isAuthenticated } = useAuth();
  console.log("isAuthenticated", isAuthenticated);
  return isAuthenticated ? children : <Navigate to="/login" />;
}

function Router() {
  const { isAuthenticated } = useAuth();

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        {isAuthenticated ? (
          <Route path="/" element={<Navigate to="/products" />} />
        ) : (
          <Route path="/" element={<Navigate to="/login" />} />
        )}
        {routerLinks().map((link) => (
          <Route
            key={link.path}
            path={link.path}
            element={
              <PrivateRoute>
                <Dashboard>{link.content ? <link.content /> : null}</Dashboard>
              </PrivateRoute>
            }
          />
        ))}
      </Routes>
    </BrowserRouter>
  );
}

export default Router;
